// extracted by mini-css-extract-plugin
export default {"thumbnailSection":"Thumbnails_thumbnailSection__h9uC3"};